module.exports = __webpack_public_path__ + "media/icons/hand-money-1787d0fe.png";